import {Nullable} from '../../app/TypeHelpers'
import {FACILITY_RESERVATION_CLASSIFICATION, RESERVATION_STATUS} from '../../CodeMaster'

export interface ReserveAvailableStatusOvernight {
    date: string
    reserveAvailable: boolean
}

export interface OvernightRentalFacilityReservation {
    id: number
    status: RESERVATION_STATUS
    startDate: string
    stayCount: number
    ownerName: Nullable<string>
    title: string
    checkinDateTime: string
    checkoutDateTime: string
}

export interface OvernightRentalOtherFacilityReservation {
    facilityId: number,
    classification: FACILITY_RESERVATION_CLASSIFICATION
    status: RESERVATION_STATUS
    startDate: string
    stayCount: number
    ownerName: Nullable<string>
    title: string
    checkinDateTime: string
    checkoutDateTime: string
}

export default class ReserveAvailabilityOvernight {
    condominiumCd: string
    facilityId: number
    targetDate: string
    reserveAvailableList: ReserveAvailableStatusOvernight[]
    currentReserves: OvernightRentalFacilityReservation[]
    otherReserves: OvernightRentalOtherFacilityReservation[]

    constructor(
        condominiumCd: string,
        facilityId: number,
        targetDate: string,
        reserveAvailableList: ReserveAvailableStatusOvernight[],
        currentReserves: OvernightRentalFacilityReservation[],
        otherReserves: OvernightRentalOtherFacilityReservation[] = [],
    ) {
        this.condominiumCd = condominiumCd
        this.facilityId = facilityId
        this.targetDate = targetDate
        this.reserveAvailableList = reserveAvailableList
        this.currentReserves = currentReserves
        this.otherReserves = otherReserves
    }

    static from(json: any): ReserveAvailabilityOvernight {
        const currentReserves: OvernightRentalFacilityReservation[] =
            json.currentReserves.map((current: any) => {
                const {status, ...rest} = current
                return {
                    ...rest,
                    status: RESERVATION_STATUS.codeToEnumConstants(status),
                }
            })

        let otherReserves: OvernightRentalOtherFacilityReservation[] = []
        if (json.otherReserves) {
            otherReserves =
                json.otherReserves.map((other: any) => {
                    const {classification, status, ...rest} = other
                    return {
                        ...rest,
                        classification: FACILITY_RESERVATION_CLASSIFICATION.codeToEnumConstants(classification),
                        status: RESERVATION_STATUS.codeToEnumConstants(status),
                    }
                })
        }

        return new ReserveAvailabilityOvernight(
            json.condominiumCd,
            json.facilityId,
            json.targetDate,
            json.reserveAvailableList,
            currentReserves,
            otherReserves,
        )
    }
}

